(function() {
  var $eb29c040bdd49490$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("modal-trigger")) return;
    class ModalTrigger extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button") || this.querySelector("summary") || this;
        this.onButtonClick = this.#onButtonClick.bind(this);
      }
      connectedCallback() {
        if (this.button) this.button.addEventListener("click", this.onButtonClick);
      }
      disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.onButtonClick);
      }
      #onButtonClick(event) {
        event.preventDefault();
        const targetId = this.getAttribute("data-target");
        const drawer = document.getElementById(targetId);
        if (drawer) {
          const disclosure = drawer.closest("details-disclosure");
          if (disclosure && typeof disclosure.open === "function") disclosure.open(); else if (drawer.tagName === "DETAILS") drawer.setAttribute("open", "");
        }
      }
    }
    customElements.define("modal-trigger", ModalTrigger);
  })();
})();